module.exports = __webpack_public_path__ + "img/gerbOpacit.c10d4181.png";